// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/home/ubuntu/code/thanktrip-admin/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/home/ubuntu/code/thanktrip-admin/src/layouts/BlankLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home' */'/home/ubuntu/code/thanktrip-admin/src/pages/Home'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/tour-sells",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/home/ubuntu/code/thanktrip-admin/src/layouts/BlankLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "Tour",
            "path": "/tour-sells/share/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourSell__Share' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourSell/Share'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "Tour",
            "path": "/tour-sells/share-detail/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourSell__ShareDetail' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourSell/ShareDetail'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "Tour",
            "path": "/tour-sells/schedules/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourSell__Schedules' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourSell/Schedules'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/live-visa-services",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/home/ubuntu/code/thanktrip-admin/src/layouts/BlankLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/live-visa-services/live/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VisaService__Live' */'/home/ubuntu/code/thanktrip-admin/src/pages/VisaService/Live'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/live-ticket-services",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/home/ubuntu/code/thanktrip-admin/src/layouts/BlankLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/live-ticket-services/live/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TicketService__Live' */'/home/ubuntu/code/thanktrip-admin/src/pages/TicketService/Live'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/live-hotel-services",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/home/ubuntu/code/thanktrip-admin/src/layouts/BlankLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/live-hotel-services/live/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HotelService__Live' */'/home/ubuntu/code/thanktrip-admin/src/pages/HotelService/Live'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/live-tour-guides",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/home/ubuntu/code/thanktrip-admin/src/layouts/BlankLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/live-tour-guides/live/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourGuide__Live' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourGuide/Live'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/live-vehicle-services",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/home/ubuntu/code/thanktrip-admin/src/layouts/BlankLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/live-vehicle-services/live/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VehicleService__Live' */'/home/ubuntu/code/thanktrip-admin/src/pages/VehicleService/Live'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/auth",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'/home/ubuntu/code/thanktrip-admin/src/layouts/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "Login",
            "path": "/auth/login",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Auth__login' */'/home/ubuntu/code/thanktrip-admin/src/pages/Auth/login'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__SecurityLayout' */'/home/ubuntu/code/thanktrip-admin/src/layouts/SecurityLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'/home/ubuntu/code/thanktrip-admin/src/layouts/BasicLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/",
                "redirect": "/dashboard",
                "exact": true
              },
              {
                "path": "/dashboard",
                "name": "Dashboard",
                "icon": "home",
                "access": "isDashboard",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/dashboard",
                    "redirect": "/dashboard/list",
                    "exact": true
                  },
                  {
                    "path": "/dashboard/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dashboard__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Dashboard/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/analytics",
                "name": "Data analytics",
                "icon": "PieChartOutlined",
                "access": "isAnalytic",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/analytics",
                    "redirect": "/analytics/list",
                    "exact": true
                  },
                  {
                    "path": "/analytics/list",
                    "name": "Data analytics",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Analytics__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Analytics/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/user-active",
                "name": "Đo lường",
                "icon": "PieChartOutlined",
                "access": "isAdmin",
                "hideChildrenInMenu": true,
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/user-active",
                    "redirect": "/user-active/list",
                    "exact": true
                  },
                  {
                    "path": "/user-active/list",
                    "name": "Đo lường",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__UserActive__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/UserActive/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/account",
                "name": "Thông tin tài khoản",
                "icon": "SolutionOutlined",
                "access": "isTravelerService",
                "hideChildrenInMenu": true,
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/account",
                    "redirect": "/account/setting",
                    "exact": true
                  },
                  {
                    "path": "/account/setting",
                    "name": "Thông Tin Tài Khoản",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__Setting' */'/home/ubuntu/code/thanktrip-admin/src/pages/Account/Setting'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/account/checkout/:package/:month",
                    "name": "Thanh toán",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__Checkout' */'/home/ubuntu/code/thanktrip-admin/src/pages/Account/Checkout'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/account/checkout/VnPayReturn",
                    "name": "Thanh toán",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__Checkout__VnPayReturn' */'/home/ubuntu/code/thanktrip-admin/src/pages/Account/Checkout/VnPayReturn'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/settings",
                "name": "Quản trị",
                "icon": "ToolOutlined",
                "access": "isTravelerService",
                "children": [
                  {
                    "path": "/account",
                    "name": "Thông tin tài khoản",
                    "exact": true
                  },
                  {
                    "path": "/staffs",
                    "name": "Danh sách Nhân sự",
                    "exact": true
                  },
                  {
                    "path": "/roles",
                    "name": "Nhóm quyền hạn",
                    "exact": true
                  }
                ],
                "exact": true
              },
              {
                "path": "/tour-collection",
                "name": "Tour",
                "icon": "AppstoreAddOutlined",
                "access": "isTravelerService",
                "children": [
                  {
                    "path": "/tours",
                    "name": "Danh sách Tour",
                    "exact": true
                  },
                  {
                    "path": "/policies",
                    "name": "Chính sách Tour",
                    "exact": true
                  },
                  {
                    "path": "/menus",
                    "name": "Thực đơn Tour",
                    "exact": true
                  }
                ],
                "exact": true
              },
              {
                "path": "/tour-collection",
                "name": "Tour",
                "icon": "AppstoreAddOutlined",
                "access": "isTourIndex",
                "children": [
                  {
                    "path": "/tours",
                    "name": "Danh sách Tour",
                    "exact": true
                  }
                ],
                "exact": true
              },
              {
                "path": "/tours",
                "name": "Danh sách Tour",
                "icon": "car",
                "access": "isTravelerService",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/tours",
                    "redirect": "/tours/list",
                    "exact": true
                  },
                  {
                    "path": "/tours/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tour__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Tour/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/tours/add",
                    "name": "Add tour",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tour__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/Tour/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/tours/:id",
                    "name": "Chi tiết tour",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tour__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Tour/Detail'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/tours/edit/:id",
                    "name": "Chỉnh sửa tour",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tour__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/Tour/Edit'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/tour-sells-collection",
                "name": "Tour đang mở bán",
                "icon": "ShoppingOutlined",
                "children": [
                  {
                    "path": "/tour-sell-open",
                    "name": "Đang mở bán",
                    "exact": true
                  },
                  {
                    "path": "/tour-sell-close",
                    "name": "Đã kết thúc",
                    "exact": true
                  }
                ],
                "exact": true
              },
              {
                "path": "/service-collection",
                "name": "Dịch vụ",
                "icon": "SwitcherOutlined",
                "access": "hasService",
                "children": [
                  {
                    "path": "/visa-services",
                    "name": "Visa",
                    "exact": true,
                    "access": "isVisaService"
                  },
                  {
                    "path": "/ticket-services",
                    "name": "Vé thăm quan",
                    "exact": true,
                    "access": "isTicketService"
                  },
                  {
                    "path": "/hotel-services",
                    "name": "Khách sạn",
                    "exact": true,
                    "access": "isHotelService"
                  },
                  {
                    "path": "/tour-guides",
                    "name": "Hướng dẫn viên",
                    "exact": true
                  },
                  {
                    "path": "/vehicle-services",
                    "name": "Xe du lịch",
                    "exact": true
                  }
                ],
                "exact": true
              },
              {
                "path": "/visa-services",
                "name": "Dịch vụ Visa",
                "icon": "ShoppingOutlined",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/visa-services",
                    "redirect": "/visa-services/list",
                    "exact": true
                  },
                  {
                    "path": "/visa-services/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VisaService__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/VisaService/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/visa-services/add",
                    "name": "Thêm mới visa",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VisaService__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/VisaService/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/visa-services/edit/:id",
                    "name": "Cập nhật visa",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VisaService__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/VisaService/Edit'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/visa-services/:id",
                    "name": "Thông tin visa",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VisaService__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/VisaService/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/tour-guides",
                "name": "Hướng dẫn viên",
                "icon": "UserOutlined",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/tour-guides",
                    "redirect": "/tour-guides/list",
                    "exact": true
                  },
                  {
                    "path": "/tour-guides/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourGuide__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourGuide/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/tour-guides/add",
                    "name": "Thêm mới",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourGuide__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourGuide/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/tour-guides/edit/:id",
                    "name": "Cập nhật",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourGuide__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourGuide/Edit'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/tour-guides/:id",
                    "name": "Thông tin",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourGuide__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourGuide/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/vehicle-services",
                "name": "Xe du lịch",
                "icon": "UserOutlined",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/vehicle-services",
                    "redirect": "/vehicle-services/list",
                    "exact": true
                  },
                  {
                    "path": "/vehicle-services/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VehicleService__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/VehicleService/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/vehicle-services/add",
                    "name": "Thêm mới",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VehicleService__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/VehicleService/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/vehicle-services/edit/:id",
                    "name": "Cập nhật",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VehicleService__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/VehicleService/Edit'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/vehicle-services/:id",
                    "name": "Thông tin",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VehicleService__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/VehicleService/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/ticket-services",
                "name": "Dịch vụ vé thăm quan",
                "icon": "ShoppingOutlined",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/ticket-services",
                    "redirect": "/ticket-services/list",
                    "exact": true
                  },
                  {
                    "path": "/ticket-services/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TicketService__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/TicketService/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/ticket-services/add",
                    "name": "Thêm mới vé thăm quan",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TicketService__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/TicketService/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/ticket-services/edit/:id",
                    "name": "Cập nhật vé thăm quan",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TicketService__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/TicketService/Edit'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/ticket-services/:id",
                    "name": "Thông tin vé thăm quan",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TicketService__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/TicketService/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/hotel-services",
                "name": "Dịch vụ Hotel",
                "icon": "ShoppingOutlined",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/hotel-services",
                    "redirect": "/hotel-services/list",
                    "exact": true
                  },
                  {
                    "path": "/hotel-services/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HotelService__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/HotelService/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/hotel-services/add",
                    "name": "Thêm mới hotel",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HotelService__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/HotelService/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/hotel-services/edit/:id",
                    "name": "Cập nhật hotel",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HotelService__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/HotelService/Edit'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/hotel-services/:id",
                    "name": "Thông tin hotel",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HotelService__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/HotelService/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/tour-sell-open",
                "name": "Đang mở bán",
                "icon": "ShoppingOutlined",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/tour-sell-open",
                    "redirect": "/tour-sell-open/list/open",
                    "exact": true
                  },
                  {
                    "path": "/tour-sell-open/list/:status",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourSell__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourSell/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/tour-sell-open/add",
                    "name": "Thêm Tour mở bán",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourSell__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourSell/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/tour-sell-open/detail/:tour",
                    "name": "Chi tiết Tour mở bán",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourSell__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourSell/Detail'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/tour-sell-open/edit/:tour",
                    "name": "Chỉnh sửa Tour mở bán",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourSell__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourSell/Edit'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/tour-sell-close",
                "name": "Đã kết thúc",
                "icon": "ShoppingOutlined",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/tour-sell-close",
                    "redirect": "/tour-sell-close/list/close",
                    "exact": true
                  },
                  {
                    "path": "/tour-sell-close/list/:status",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TourSell__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/TourSell/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/booking",
                "name": "Yêu cầu từ ThankTrip",
                "icon": "inbox",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/booking",
                    "redirect": "/booking/list",
                    "exact": true
                  },
                  {
                    "path": "/booking/list",
                    "name": "Booking List",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Booking__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Booking/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/booking/add",
                    "name": "Booking Add",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Booking__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/Booking/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/booking/:id",
                    "name": "Booking Detail",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Booking__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Booking/Detail'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/booking/edit/:id",
                    "name": "Booking Edit",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Booking__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/Booking/Edit'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/booking/quotation/:id/create",
                    "name": "Booking Quotation Create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Booking__QuotationForm' */'/home/ubuntu/code/thanktrip-admin/src/pages/Booking/QuotationForm'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/booking/quotation/:id/edit",
                    "name": "Booking Quotation Edit",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Booking__QuotationForm' */'/home/ubuntu/code/thanktrip-admin/src/pages/Booking/QuotationForm'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/policies",
                "name": "Chính sách Tour",
                "icon": "fileProtect",
                "access": "isTravelerService",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/policies",
                    "redirect": "/policies/list",
                    "exact": true
                  },
                  {
                    "path": "/policies/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Policy__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Policy/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/menus",
                "name": "Thực đơn Tour",
                "icon": "read",
                "access": "isTravelerService",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/menus",
                    "redirect": "/menus/list",
                    "exact": true
                  },
                  {
                    "path": "/menus/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Menu__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Menu/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/staffs",
                "name": "Danh sách Nhân sự",
                "icon": "team",
                "access": "isTravelerService",
                "hideChildrenInMenu": true,
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/staffs",
                    "redirect": "/staffs/list",
                    "exact": true
                  },
                  {
                    "path": "/staffs/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Staff__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Staff/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/staffs/:id",
                    "name": "Thông tin tài khoản",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Staff__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Staff/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/agents",
                "name": "Danh sách Đại lý",
                "icon": "team",
                "access": "isTravelerService",
                "hideChildrenInMenu": true,
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/agents",
                    "redirect": "/agents/list",
                    "exact": true
                  },
                  {
                    "path": "/agents/list",
                    "name": "Danh sách Đại lý",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Staff__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Staff/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/agents/:id",
                    "name": "Thông tin tài khoản",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Staff__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Staff/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/collaborators",
                "name": "Danh sách CTV",
                "icon": "team",
                "access": "isTravelerService",
                "hideChildrenInMenu": true,
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/collaborators",
                    "redirect": "/collaborators/list",
                    "exact": true
                  },
                  {
                    "path": "/collaborators/list",
                    "name": "Danh sách CTV",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Staff__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Staff/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/collaborators/:id",
                    "name": "Thông tin tài khoản",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Staff__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Staff/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/order-collection",
                "name": "Danh sách đơn hàng",
                "icon": "ShoppingCartOutlined",
                "children": [
                  {
                    "path": "/orders",
                    "name": "Tour",
                    "exact": true
                  },
                  {
                    "path": "/visa",
                    "name": "Visa",
                    "exact": true
                  },
                  {
                    "path": "/hotel-orders",
                    "name": "Khách sạn",
                    "exact": true
                  },
                  {
                    "path": "/combo-orders",
                    "name": "Combo",
                    "exact": true
                  }
                ],
                "exact": true
              },
              {
                "path": "/visa",
                "name": "Danh sách đơn hàng Visa",
                "icon": "AuditOutlined",
                "hideChildrenInMenu": true,
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/visa",
                    "redirect": "/visa/list",
                    "exact": true
                  },
                  {
                    "path": "/visa/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Visa__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Visa/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/visa/add",
                    "name": "Thêm mới đơn hàng Visa",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Visa__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/Visa/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/visa/edit/:id",
                    "name": "Chỉnh sửa đơn hàng Visa",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Visa__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/Visa/Edit'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/visa/:id",
                    "name": "Chi tiết đơn hàng Visa",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Visa__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Visa/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/orders",
                "name": "Danh sách đơn hàng",
                "icon": "ShoppingCartOutlined",
                "hideChildrenInMenu": true,
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/orders",
                    "redirect": "/orders/list",
                    "exact": true
                  },
                  {
                    "path": "/orders/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Order/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/orders/add",
                    "name": "Thêm mới đơn hàng",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/Order/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/orders/edit/:id",
                    "name": "Cập nhật đơn hàng",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/Order/Edit'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/orders/:id",
                    "name": "Thông tin hóa đơn",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Order/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/hotel-orders",
                "name": "Đơn hàng khách sạn",
                "icon": "ShoppingCartOutlined",
                "hideChildrenInMenu": true,
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/hotel-orders",
                    "redirect": "/hotel-orders/list",
                    "exact": true
                  },
                  {
                    "path": "/hotel-orders/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HotelOrder__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/HotelOrder/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/hotel-orders/add",
                    "name": "Thêm mới đơn hàng",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HotelOrder__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/HotelOrder/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/hotel-orders/edit/:id",
                    "name": "Cập nhật đơn hàng",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HotelOrder__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/HotelOrder/Edit'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/hotel-orders/:id",
                    "name": "Thông tin hóa đơn",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HotelOrder__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/HotelOrder/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/combo-orders",
                "name": "Đơn hàng combo",
                "icon": "ShoppingCartOutlined",
                "hideChildrenInMenu": true,
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/combo-orders",
                    "redirect": "/combo-orders/list",
                    "exact": true
                  },
                  {
                    "path": "/combo-orders/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ComboOrder__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/ComboOrder/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/combo-orders/add",
                    "name": "Thêm mới đơn hàng",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ComboOrder__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/ComboOrder/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/combo-orders/edit/:id",
                    "name": "Cập nhật đơn hàng",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ComboOrder__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/ComboOrder/Edit'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/combo-orders/:id",
                    "name": "Thông tin hóa đơn",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ComboOrder__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/ComboOrder/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/cost-collection",
                "name": "Chi phí - Công nợ",
                "icon": "DollarCircleOutlined",
                "access": "isTravelerService",
                "children": [
                  {
                    "path": "/costs",
                    "name": "Danh sách",
                    "exact": true
                  },
                  {
                    "path": "/cost-categories",
                    "name": "Cấu hình chi phí",
                    "exact": true
                  }
                ],
                "exact": true
              },
              {
                "path": "/costs",
                "name": "Danh sách",
                "icon": "DollarCircleOutlined",
                "access": "isTravelerService",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/costs",
                    "redirect": "/costs/list",
                    "exact": true
                  },
                  {
                    "path": "/costs/list",
                    "name": "Danh sách",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Cost__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Cost/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/costs/:id",
                    "name": "Chi tiết",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Cost__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Cost/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/cost-categories",
                "name": "Cấu hình chi phí",
                "icon": "DollarCircleOutlined",
                "access": "isTravelerService",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/cost-categories",
                    "redirect": "/cost-categories/list",
                    "exact": true
                  },
                  {
                    "path": "/cost-categories/list",
                    "name": "Cấu hình chi phí",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CostCategory__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/CostCategory/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/suppliers",
                "name": "Đối tác - Nhà cung cấp",
                "icon": "team",
                "access": "isTravelerService",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/suppliers",
                    "redirect": "/suppliers/list",
                    "exact": true
                  },
                  {
                    "path": "/suppliers/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Supplier__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Supplier/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/suppliers/detail/:id",
                    "name": "Chi tiết",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Supplier__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Supplier/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/customers",
                "name": "Khách hàng",
                "icon": "ContactsOutlined",
                "hideChildrenInMenu": true,
                "access": "isTravelerService",
                "routes": [
                  {
                    "path": "/customers",
                    "redirect": "/customers/list",
                    "exact": true
                  },
                  {
                    "path": "/customers/list",
                    "name": "Khách hàng",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Customer/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/customers/:id",
                    "name": "Chi tiết khách hàng",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Customer/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/blogs",
                "name": "Blogs",
                "icon": "HighlightOutlined",
                "hideChildrenInMenu": true,
                "access": "isAdmin",
                "routes": [
                  {
                    "path": "/blogs",
                    "redirect": "/blogs/list",
                    "exact": true
                  },
                  {
                    "path": "/blogs/list",
                    "name": "Blog",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Blog__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Blog/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/blogs/add",
                    "name": "Blog add",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Blog__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/Blog/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/blogs/edit/:id",
                    "name": "Chỉnh sửa blog",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Blog__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/Blog/Edit'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/roles",
                "name": "Nhóm quyền hạn",
                "icon": "LockOutlined",
                "hideChildrenInMenu": true,
                "access": "isAdmin",
                "routes": [
                  {
                    "path": "/roles",
                    "redirect": "/roles/list",
                    "exact": true
                  },
                  {
                    "path": "/roles/list",
                    "name": "Nhóm quyền hạn",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Role__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Role/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/staffs",
                "name": "Danh sách Nhân sự",
                "icon": "team",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/staffs",
                    "redirect": "/staffs/list",
                    "exact": true
                  },
                  {
                    "path": "/staffs/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Staff__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Staff/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/staffs/:id",
                    "name": "Thông tin tài khoản",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Staff__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Staff/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/agent-collaborator-collection",
                "name": "Đại lý & CTV",
                "icon": "BranchesOutlined",
                "routes": [
                  {
                    "path": "/agents",
                    "name": "Danh sách Đại lý",
                    "exact": true
                  },
                  {
                    "path": "/collaborators",
                    "name": "Danh sách CTV",
                    "exact": true
                  }
                ]
              },
              {
                "path": "/print-library",
                "name": "Thư viện bản in",
                "icon": "BgColorsOutlined",
                "access": "isTravelerService",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/print-library",
                    "redirect": "/print-library/list",
                    "exact": true
                  },
                  {
                    "path": "/print-library/list",
                    "name": "Thư viện bản in",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PrintLibrary__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/PrintLibrary/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/print-library/checkout/:package/:month",
                    "name": "Thanh toán",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PrintLibrary__Checkout' */'/home/ubuntu/code/thanktrip-admin/src/pages/PrintLibrary/Checkout'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/print-library/checkout/VnPayReturn",
                    "name": "Thanh toán",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PrintLibrary__Checkout__VnPayReturn' */'/home/ubuntu/code/thanktrip-admin/src/pages/PrintLibrary/Checkout/VnPayReturn'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/documents",
                "name": "Hướng dẫn sử dụng",
                "icon": "VideoCameraOutlined",
                "access": "isTravelerService",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/documents",
                    "redirect": "/documents/list",
                    "exact": true
                  },
                  {
                    "path": "/documents/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Document__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Document/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/policy-sell",
                "name": "Điều khoản mở bán",
                "icon": "FlagOutlined",
                "access": "isTravelerService",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/policy-sell",
                    "redirect": "/policy-sell/list",
                    "exact": true
                  },
                  {
                    "path": "/policy-sell/list",
                    "name": "Điều khoản mở bán",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PolicySell__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/PolicySell/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/activities",
                "name": "Lịch sử hoạt động",
                "icon": "RedoOutlined",
                "access": "isTravelerService",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/activities",
                    "redirect": "/activities/list",
                    "exact": true
                  },
                  {
                    "path": "/activities/list",
                    "name": "Lịch sử hoạt động",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Activity__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Activity/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/automatic-quote",
                "name": "Coming Soon",
                "icon": "MailOutlined",
                "access": "isTravelerService",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/automatic-quote",
                    "redirect": "/automatic-quote/list",
                    "exact": true
                  },
                  {
                    "path": "/automatic-quote/list",
                    "name": "Báo Giá Tự Động",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AutomaticQuote__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/AutomaticQuote/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/quote",
                "name": "Danh Sách Báo Giá",
                "icon": "LineChartOutlined",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/quote",
                    "redirect": "/quote/list",
                    "exact": true
                  },
                  {
                    "path": "/quote/list",
                    "name": "Danh sách báo giá",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Quote__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Quote/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/automatic-quote",
                "name": "Báo Giá Tự Động",
                "icon": "profile",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/automatic-quote",
                    "redirect": "/automatic-quote/list",
                    "exact": true
                  },
                  {
                    "path": "/automatic-quote/list",
                    "name": "Báo Giá Tự Động",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AutomaticQuote__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/AutomaticQuote/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/robot",
                "name": "Trợ lý ảo",
                "icon": "SmileOutlined",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/robot",
                    "redirect": "/robot/list",
                    "exact": true
                  },
                  {
                    "path": "/robot/list",
                    "name": "Trợ lý ảo",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Robot__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Robot/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/crm",
                "name": "CRM",
                "icon": "UserAddOutlined",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/crm",
                    "redirect": "/crm/list",
                    "exact": true
                  },
                  {
                    "path": "/crm/list",
                    "name": "CRM",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Crm__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Crm/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/trips",
                "name": "Trips",
                "icon": "rocket",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/trips",
                    "redirect": "/trips/list",
                    "exact": true
                  },
                  {
                    "path": "/trips/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Trip__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Trip/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/trips/add",
                    "name": "Trip Detail",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Trip__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/Trip/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/trips/:id",
                    "name": "Trip Detail",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Trip__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/Trip/Edit'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/places",
                "name": "Places",
                "icon": "environment",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/places",
                    "redirect": "/places/list",
                    "exact": true
                  },
                  {
                    "path": "/places/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Place__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Place/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/places/add",
                    "name": "Add place",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Place__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/Place/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/places/:id",
                    "name": "Edit place",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Place__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/Place/Edit'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/partner-collection",
                "name": "Đối tác lữ hành",
                "icon": "UsergroupAddOutlined",
                "access": "isMod",
                "children": [
                  {
                    "path": "/partner",
                    "name": "Danh sách đối tác",
                    "exact": true
                  },
                  {
                    "path": "/user-active",
                    "name": "Đo lường",
                    "exact": true
                  },
                  {
                    "path": "/upgrade-request",
                    "name": "Yêu cầu nâng cấp",
                    "exact": true
                  },
                  {
                    "path": "/print-request",
                    "name": "Nâng cấp bản in",
                    "exact": true
                  }
                ],
                "exact": true
              },
              {
                "path": "/suppliers",
                "name": "Đối tác khác",
                "icon": "team",
                "hideChildrenInMenu": true,
                "access": "isMod",
                "routes": [
                  {
                    "path": "/suppliers",
                    "redirect": "/suppliers/list",
                    "exact": true
                  },
                  {
                    "path": "/suppliers/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Supplier__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Supplier/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/suppliers/detail/:id",
                    "name": "Chi tiết",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Supplier__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Supplier/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/partner",
                "name": "Danh sách đối tác",
                "icon": "userSwitch",
                "access": "isMod",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/partner",
                    "redirect": "/partner/list",
                    "exact": true
                  },
                  {
                    "path": "/partner/list",
                    "name": "Danh sách đối tác",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Partner__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Partner/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/partner/:id",
                    "name": "Chi tiết đối tác",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Partner__Detail' */'/home/ubuntu/code/thanktrip-admin/src/pages/Partner/Detail'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/upgrade-request",
                "name": "Yêu cầu nâng cấp",
                "icon": "TrophyOutlined",
                "access": "isMod",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/upgrade-request",
                    "redirect": "/upgrade-request/list",
                    "exact": true
                  },
                  {
                    "path": "/upgrade-request/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__UpgradeRequest__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/UpgradeRequest/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/print-request",
                "name": "Nâng cấp bản in",
                "icon": "TrophyOutlined",
                "access": "isMod",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/print-request",
                    "redirect": "/print-request/list",
                    "exact": true
                  },
                  {
                    "path": "/print-request/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PrintRequest__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/PrintRequest/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/reservation",
                "name": "Reservation",
                "icon": "environment",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/reservation",
                    "redirect": "/reservation/list",
                    "exact": true
                  },
                  {
                    "path": "/reservation/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Reservation__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Reservation/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/users",
                "name": "Users",
                "icon": "user",
                "access": "isAdmin",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/users",
                    "access": "isAdmin",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__User__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/User/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/users/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__User__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/User/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/users/add",
                    "name": "Add user",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__User__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/User/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/users/:id",
                    "name": "User Detail",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__User__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/User/Edit'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/areas",
                "name": "Areas",
                "icon": "BorderOuterOutlined",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/areas",
                    "redirect": "/areas/list",
                    "exact": true
                  },
                  {
                    "path": "/areas/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Area__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Area/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/areas/add",
                    "name": "Add area",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Area__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/Area/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/areas/:id",
                    "name": "Edit area",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Area__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/Area/Edit'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/trip-categories",
                "name": "Trip Categories",
                "icon": "alignLeft",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/trip-categories",
                    "redirect": "/trip-categories/list",
                    "exact": true
                  },
                  {
                    "path": "/trip-categories/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TripCategory__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/TripCategory/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/trip-categories/add",
                    "name": "Add trip category",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TripCategory__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/TripCategory/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/trip-categories/:id",
                    "name": "Edit trip category",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TripCategory__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/TripCategory/Edit'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/place-utilities",
                "name": "Place Utilities",
                "icon": "alignLeft",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/place-utilities",
                    "redirect": "/place-utilities/list",
                    "exact": true
                  },
                  {
                    "path": "/place-utilities/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PlaceUtility__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/PlaceUtility/List'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/place-utilities/add",
                    "name": "Add place utility",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PlaceUtility__Add' */'/home/ubuntu/code/thanktrip-admin/src/pages/PlaceUtility/Add'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/place-utilities/:id",
                    "name": "Edit utility",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PlaceUtility__Edit' */'/home/ubuntu/code/thanktrip-admin/src/pages/PlaceUtility/Edit'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/receipt",
                "name": "Phiếu thu",
                "icon": "snippets",
                "access": "isMod",
                "hideChildrenInMenu": true,
                "routes": [
                  {
                    "path": "/receipt",
                    "redirect": "/receipt/list",
                    "exact": true
                  },
                  {
                    "path": "/receipt/list",
                    "name": "Danh sách phiếu thu",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Receipt__List' */'/home/ubuntu/code/thanktrip-admin/src/pages/Receipt/List'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/ubuntu/code/thanktrip-admin/src/pages/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/ubuntu/code/thanktrip-admin/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      }
    ]
  },
  {
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/ubuntu/code/thanktrip-admin/src/pages/404'), loading: LoadingComponent}),
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
